function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var Order = require('./order');
var Slip = require('../../../lib/saito/slip')["default"];
var Transaction = require('../../../lib/saito/transaction')["default"];
var SaitoNFT = require('../../../lib/saito/ui/saito-nft/saito-nft');
var _require = require('saito-js/lib/slip'),
  SlipType = _require.SlipType;
var _require2 = require('saito-js/lib/transaction'),
  TransactionType = _require2.TransactionType;
var _require3 = require('./scripting'),
  createListingScript = _require3.createListingScript,
  createPurchaseScript = _require3.createPurchaseScript,
  executeListingScript = _require3.executeListingScript,
  returnCreatedNftTuples = _require3.returnCreatedNftTuples,
  returnSpentNftTuples = _require3.returnSpentNftTuples,
  signAccessScriptWitness = _require3.signAccessScriptWitness;
var _require4 = require('./helpers'),
  transactionIndexInBlock = _require4.transactionIndexInBlock,
  returnAmountPaidInPurchase = _require4.returnAmountPaidInPurchase,
  returnPaymentUtxoFromPurchase = _require4.returnPaymentUtxoFromPurchase,
  slipPublicKey = _require4.slipPublicKey,
  serializeSlip = _require4.serializeSlip,
  paymentInputFromOrder = _require4.paymentInputFromOrder,
  listingInputSlipJsonFromRecord = _require4.listingInputSlipJsonFromRecord,
  listingTxmsg = _require4.listingTxmsg,
  listRustP2shInputIndexes = _require4.listRustP2shInputIndexes;
function partitionCustodyDeposit(row_custody, take_qty, row_qty) {
  var buyer = row_qty > 0 ? row_custody * BigInt(take_qty) / BigInt(row_qty) : 0n;
  return {
    buyer: buyer,
    remaining: row_custody - buyer
  };
}
function isWeb3PurchaseMessage() {
  var txmsg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var ticker = String(txmsg.web3_ticker || '').trim().toUpperCase();
  return ticker !== '' && ticker !== 'SAITO';
}

// inbound_payment_uuid is the external Mixin transaction hash.
// transfer_uuid is the decimal transfers.id. Other shapes are not retained.
function storePaymentIdentifiers() {
  var txmsg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var inbound = typeof txmsg.inbound_payment_uuid === 'string' ? txmsg.inbound_payment_uuid.trim() : '';
  var rawTransfer = txmsg.transfer_uuid;
  var transfer = '';
  if (typeof rawTransfer === 'number' && Number.isSafeInteger(rawTransfer) && rawTransfer > 0) {
    transfer = String(rawTransfer);
  } else if (typeof rawTransfer === 'string' && /^[1-9]\d*$/.test(rawTransfer.trim())) {
    var parsed = Number(rawTransfer.trim());
    transfer = Number.isSafeInteger(parsed) ? rawTransfer.trim() : '';
  }
  return {
    inbound_payment_uuid: inbound,
    transfer_uuid: transfer
  };
}
function web3RefundRecipient(app) {
  var txmsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  for (var _i = 0, _arr = [txmsg.refund, txmsg.buyer]; _i < _arr.length; _i++) {
    var _app$crypto;
    var candidate = _arr[_i];
    var key = String(candidate || '').trim();
    if (key && typeof (app === null || app === void 0 || (_app$crypto = app.crypto) === null || _app$crypto === void 0 ? void 0 : _app$crypto.isPublicKey) === 'function' && app.crypto.isPublicKey(key)) {
      return key;
    }
  }
  return '';
}
function purchaseSenderPublicKey(tx) {
  var from = (tx === null || tx === void 0 ? void 0 : tx.from) || [];
  var _iterator = _createForOfIteratorHelper(from),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var slip = _step.value;
      var key = String((slip === null || slip === void 0 ? void 0 : slip.publicKey) || '').trim();
      if (key) {
        return key;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return '';
}
function web3PaymentProcessorKeys(mod) {
  var configured = mod === null || mod === void 0 ? void 0 : mod.web3_payment_processor_publickey;
  var listed = Array.isArray(configured) ? configured : configured ? [configured] : [];
  var keys = [];
  for (var _i2 = 0, _arr2 = [].concat(_toConsumableArray(listed), [mod === null || mod === void 0 ? void 0 : mod.publicKey]); _i2 < _arr2.length; _i2++) {
    var candidate = _arr2[_i2];
    var key = String(candidate || '').trim();
    if (key && !keys.includes(key)) {
      keys.push(key);
    }
  }
  return keys;
}
function p2shPaymentRecipient(app, p2sh_address, context) {
  var recipient = slipPublicKey(app, p2sh_address) || p2sh_address;
  if (!recipient || recipient === p2sh_address && (p2sh_address === null || p2sh_address === void 0 ? void 0 : p2sh_address.length) === 66 && p2sh_address !== null && p2sh_address !== void 0 && p2sh_address.startsWith('00')) {
    var log = context === 'createPurchaseAssetTransaction' ? console.error : console.log;
    log("Store: ".concat(context, " slipPublicKey failed"), p2sh_address, recipient);
    throw new Error('invalid recipient public key');
  }
  return recipient;
}
module.exports = {
  createListAssetTransaction: function createListAssetTransaction(nft) {
    var _arguments = arguments,
      _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _listing$quantity_tot;
      var listing, script_info, txmsg, slip_public_key, newtx, is_store_rental, listing_transfer_data, _t, _t2, _t3, _t4;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            listing = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {};
            if (!(!(nft !== null && nft !== void 0 && nft.tx) && typeof (nft === null || nft === void 0 ? void 0 : nft.fetchTransaction) === 'function')) {
              _context.n = 1;
              break;
            }
            _context.n = 1;
            return new Promise(function (resolve) {
              var settled = false;
              var finish = function finish() {
                if (!settled) {
                  settled = true;
                  resolve();
                }
              };
              nft.fetchTransaction(finish);
              setTimeout(finish, 8000);
            });
          case 1:
            if (nft !== null && nft !== void 0 && nft.tx) {
              _context.n = 2;
              break;
            }
            throw new Error('NFT transaction is missing — cannot list without original NFT data');
          case 2:
            if (!nft.txmsg && typeof nft.buildNFTData === 'function') {
              nft.buildNFTData(nft.tx);
            }
            if (nft.txmsg) {
              _context.n = 3;
              break;
            }
            throw new Error('NFT transaction message is missing — cannot list without original NFT data');
          case 3:
            _t = createListingScript;
            _t2 = _this.app;
            _context.n = 4;
            return _this.app.wallet.getPublicKey();
          case 4:
            _t3 = _context.v;
            _t4 = _this.store_public_key;
            script_info = _t(_t2, {
              seller_publickey: _t3,
              store_publickey: _t4
            });
            //
            // create the listing txmsg — keep NFT payload from prior tx, but never carry
            // prior Store control fields (e.g. delist-asset request / spent access_scripts).
            //
            txmsg = JSON.parse(JSON.stringify(nft.txmsg));
            delete txmsg.request;
            delete txmsg.access_script;
            delete txmsg.access_hash;
            delete txmsg.p2sh_address;
            delete txmsg.access_scripts;
            delete txmsg.fulfill_sale;
            delete txmsg.listing_signature;
            delete txmsg.listing;
            txmsg.module = 'Store';
            txmsg.request = 'list-asset';
            txmsg.access_script = script_info.access_script;
            txmsg.access_hash = script_info.access_hash;
            txmsg.p2sh_address = script_info.p2sh_address;
            txmsg.listing = listing;

            //
            // create the listing tx
            //
            slip_public_key = p2shPaymentRecipient(_this.app, script_info.p2sh_address, 'createListAssetTransaction');
            _context.n = 5;
            return _this.app.wallet.createNFTTransaction(nft, slip_public_key, (_listing$quantity_tot = listing.quantity_total) !== null && _listing$quantity_tot !== void 0 ? _listing$quantity_tot : nft.amount, BigInt(0), BigInt(0), txmsg);
          case 5:
            newtx = _context.v;
            // wallet.createNFTTransaction does Object.assign(tx_msg, nft.txmsg), which can
            // reintroduce stale Store fields from a prior delist/list. Force list-asset values.
            newtx.msg = newtx.msg || {};
            newtx.msg.module = 'Store';
            newtx.msg.request = 'list-asset';
            newtx.msg.access_script = script_info.access_script;
            newtx.msg.access_hash = script_info.access_hash;
            newtx.msg.p2sh_address = script_info.p2sh_address;
            newtx.msg.listing = listing;
            delete newtx.msg.access_scripts;
            delete newtx.msg.fulfill_sale;
            delete newtx.msg.listing_signature;

            // Listing user → Store for store-nft-rental is the authorized/delegated hop.
            // Other NFT types leave data default (no delegated flag).
            is_store_rental = typeof nft.returnType === 'function' && nft.returnType() === 'store-nft-rental' || String((listing === null || listing === void 0 ? void 0 : listing.listing_mode) || '').toLowerCase() === 'rent';
            if (is_store_rental) {
              nft.nft_type = 'store-nft-rental';
            }
            listing_transfer_data = is_store_rental ? {
              delegated: true
            } : {};
            _context.n = 6;
            return nft.modifyBeforeSend(newtx, _this.store_public_key, listing_transfer_data);
          case 6:
            newtx = _context.v;
            if (newtx) {
              _context.n = 7;
              break;
            }
            throw new Error('NFT transfer blocked before list-asset broadcast');
          case 7:
            newtx.msg = newtx.msg || {};
            newtx.msg.module = 'Store';
            newtx.msg.request = 'list-asset';
            newtx.msg.access_script = script_info.access_script;
            newtx.msg.access_hash = script_info.access_hash;
            newtx.msg.p2sh_address = script_info.p2sh_address;
            newtx.msg.listing = listing;
            delete newtx.msg.access_scripts;
            delete newtx.msg.fulfill_sale;
            delete newtx.msg.listing_signature;
            _context.n = 8;
            return newtx.sign();
          case 8:
            console.log('Store: createListAssetTransaction complete', newtx.signature);
            return _context.a(2, newtx);
        }
      }, _callee);
    }))();
  },
  receiveListAssetTransaction: function receiveListAssetTransaction(blk, tx) {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var nft, txmsg, spent_tuples, created_tuples, slip_key, _txmsg$listing, _txmsg$fulfill_sale, _vault_mod$peer, my_key, nft_type, is_store_rental, _created_tuples, to_me, vault_mod, newTx, _t5, _t6, _t7;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            console.log('Store: receiveListAssetTransaction start', tx.signature);
            nft = new SaitoNFT(_this2.app, _this2, tx, null);
            txmsg = tx.returnMessage();
            if (!txmsg.fulfill_sale) {
              _context2.n = 2;
              break;
            }
            _context2.n = 1;
            return _this2.receiveFulfillmentTransaction(blk, tx);
          case 1:
            _context2.n = 8;
            break;
          case 2:
            _context2.p = 2;
            spent_tuples = returnSpentNftTuples(tx);
            created_tuples = returnCreatedNftTuples(tx);
            slip_key = slipPublicKey(_this2.app, txmsg.p2sh_address || '') || txmsg.p2sh_address || ''; //
            // inventory moved from one listing position to another
            //
            _t5 = spent_tuples.some(function (tuple) {
              return tuple.custody_public_key === slip_key;
            }) && created_tuples.some(function (tuple) {
              return tuple.custody_public_key === slip_key;
            });
            if (!_t5) {
              _context2.n = 4;
              break;
            }
            _context2.n = 3;
            return executeListingScript(_this2.app, txmsg.access_script || '', _this2.store_public_key);
          case 3:
            _t5 = _context2.v;
          case 4:
            if (!_t5) {
              _context2.n = 5;
              break;
            }
            _context2.n = 5;
            return _this2.warehouse.removeListing(nft, tx, txmsg, blk);
          case 5:
            _context2.n = 6;
            return _this2.warehouse.addListing(nft, tx, txmsg, blk);
          case 6:
            _context2.n = 8;
            break;
          case 7:
            _context2.p = 7;
            _t6 = _context2.v;
            console.error('Store: receiveListAssetTransaction failed', _t6);
            if (_t6 !== null && _t6 !== void 0 && _t6.stack) {
              console.error(_t6.stack);
            }
          case 8:
            _context2.p = 8;
            my_key = String(_this2.publicKey || '').trim();
            nft_type = (typeof nft.returnType === 'function' ? nft.returnType() : '') || nft.nft_type || '';
            is_store_rental = nft_type === 'store-nft-rental' || String((txmsg === null || txmsg === void 0 || (_txmsg$listing = txmsg.listing) === null || _txmsg$listing === void 0 ? void 0 : _txmsg$listing.listing_mode) || '').toLowerCase() === 'rent';
            if (!(!is_store_rental || !my_key)) {
              _context2.n = 9;
              break;
            }
            return _context2.a(2);
          case 9:
            _created_tuples = returnCreatedNftTuples(tx);
            to_me = String((txmsg === null || txmsg === void 0 || (_txmsg$fulfill_sale = txmsg.fulfill_sale) === null || _txmsg$fulfill_sale === void 0 ? void 0 : _txmsg$fulfill_sale.buyer) || '') === my_key || _created_tuples.some(function (tuple) {
              return tuple.custody_public_key === my_key;
            });
            if (to_me) {
              _context2.n = 10;
              break;
            }
            return _context2.a(2);
          case 10:
            vault_mod = _this2.app.modules.returnModule('Vault');
            if (!(!vault_mod || typeof vault_mod.createCheckOutRentalTransaction !== 'function')) {
              _context2.n = 11;
              break;
            }
            return _context2.a(2);
          case 11:
            _context2.n = 12;
            return vault_mod.createCheckOutRentalTransaction(tx);
          case 12:
            newTx = _context2.v;
            if (newTx) {
              _context2.n = 13;
              break;
            }
            return _context2.a(2);
          case 13:
            if ((_vault_mod$peer = vault_mod.peer) !== null && _vault_mod$peer !== void 0 && _vault_mod$peer.publicKey) {
              _context2.n = 14;
              break;
            }
            return _context2.a(2);
          case 14:
            _this2.app.network.sendRequestAsTransaction('vault checkout rental', newTx.serialize_to_web(_this2.app), function (res) {
              var file_id = (res === null || res === void 0 ? void 0 : res.file_id) || '';
              if (res && res.status === 'ok') {
                alert("Vault checkout: Archive update succeeded".concat(file_id ? " (".concat(file_id, ")") : ''));
              } else {
                var err = (res === null || res === void 0 ? void 0 : res.err) || 'unknown';
                alert("Vault checkout: Archive update failed".concat(file_id ? " (".concat(file_id, ")") : '', ": ").concat(err));
              }
            }, vault_mod.peer.publicKey);
            _context2.n = 16;
            break;
          case 15:
            _context2.p = 15;
            _t7 = _context2.v;
          case 16:
            return _context2.a(2);
        }
      }, _callee2, null, [[8, 15], [2, 7]]);
    }))();
  },
  receiveFulfillmentTransaction: function receiveFulfillmentTransaction(blk, tx) {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var nft, txmsg;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            console.log('Store: receiveFulfillmentTransaction start', tx.signature);
            nft = new SaitoNFT(_this3.app, _this3, tx, null);
            txmsg = tx.returnMessage();
            _context3.n = 1;
            return _this3.warehouse.confirmSettlement(blk, tx);
          case 1:
            _context3.n = 2;
            return _this3.warehouse.addListing(nft, tx, txmsg, blk);
          case 2:
            return _context3.a(2);
        }
      }, _callee3);
    }))();
  },
  attachFulfillmentTxmsg: function attachFulfillmentTxmsg(fulfillment_tx, order_row) {
    var _ref, _order_row$price, _this$app$wallet$conv, _fulfillment_tx$msg;
    var listing_rows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var listing_tx = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    if (!fulfillment_tx || !order_row || !listing_rows.length || !listing_tx) {
      throw new Error('fulfillment transaction, order, listing rows, and listing tx are required');
    }
    var primary_listing_row = listing_rows[0];
    var listing_txmsg = listingTxmsg(listing_tx);
    var buyer = order_row.buyer || '';
    var buy_qty = Number(order_row.quantity) || 1;
    var unit_price = Number((_ref = (_order_row$price = order_row.price) !== null && _order_row$price !== void 0 ? _order_row$price : primary_listing_row.price) !== null && _ref !== void 0 ? _ref : 0);
    var relist_listing_row = primary_listing_row;
    var relist_remainder = 0;
    var _iterator2 = _createForOfIteratorHelper(listing_rows),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _listing_row$quantity, _listing_row$take_qty;
        var listing_row = _step2.value;
        var row_qty = Number((_listing_row$quantity = listing_row.quantity) !== null && _listing_row$quantity !== void 0 ? _listing_row$quantity : 1);
        var take_qty = Number((_listing_row$take_qty = listing_row.take_qty) !== null && _listing_row$take_qty !== void 0 ? _listing_row$take_qty : row_qty);
        var remainder = row_qty - take_qty;
        if (remainder > 0) {
          relist_listing_row = listing_row;
          relist_remainder = remainder;
          break;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    var pay_descriptor = relist_listing_row.p2sh_address || primary_listing_row.p2sh_address || '';
    var base_listing = listing_txmsg.listing || {
      nft_id: primary_listing_row.nft_id,
      price: String((_this$app$wallet$conv = this.app.wallet.convertNolanToSaito(BigInt(unit_price))) !== null && _this$app$wallet$conv !== void 0 ? _this$app$wallet$conv : unit_price),
      denomination: 'SAITO',
      pay_descriptor: pay_descriptor
    };
    var existing_access_scripts = Array.isArray((_fulfillment_tx$msg = fulfillment_tx.msg) === null || _fulfillment_tx$msg === void 0 ? void 0 : _fulfillment_tx$msg.access_scripts) ? fulfillment_tx.msg.access_scripts : null;
    fulfillment_tx.msg = _objectSpread(_objectSpread({}, JSON.parse(JSON.stringify(listing_txmsg || {}))), fulfillment_tx.msg || {});
    fulfillment_tx.msg.module = 'Store';
    fulfillment_tx.msg.request = 'list-asset';
    fulfillment_tx.msg.fulfill_sale = {
      sale_signature: order_row.order_tx_sig || order_row.signature,
      prior_inventory: primary_listing_row.signature,
      listing_signatures: listing_rows.map(function (row) {
        return row.signature;
      }).filter(Boolean),
      buyer: buyer,
      quantity: buy_qty,
      seller: relist_listing_row.seller || primary_listing_row.seller || ''
    };
    if (relist_remainder > 0) {
      fulfillment_tx.msg.access_script = relist_listing_row.access_script || '';
      fulfillment_tx.msg.access_hash = relist_listing_row.access_hash || '';
      fulfillment_tx.msg.p2sh_address = relist_listing_row.p2sh_address || '';
      fulfillment_tx.msg.listing = _objectSpread(_objectSpread({}, base_listing), {}, {
        nft_id: primary_listing_row.nft_id || base_listing.nft_id,
        denomination: base_listing.denomination || 'SAITO',
        pay_descriptor: pay_descriptor,
        nft_amount: relist_remainder,
        quantity: relist_remainder
      });
    } else {
      fulfillment_tx.msg.access_script = primary_listing_row.access_script || '';
      fulfillment_tx.msg.access_hash = primary_listing_row.access_hash || '';
      fulfillment_tx.msg.p2sh_address = primary_listing_row.p2sh_address || '';
      fulfillment_tx.msg.listing = _objectSpread(_objectSpread({}, base_listing), {}, {
        nft_id: primary_listing_row.nft_id || base_listing.nft_id,
        denomination: base_listing.denomination || 'SAITO',
        pay_descriptor: primary_listing_row.p2sh_address || pay_descriptor,
        nft_amount: 0,
        quantity: 0
      });
    }
    if (existing_access_scripts) {
      fulfillment_tx.msg.access_scripts = existing_access_scripts;
    }
    return fulfillment_tx;
  },
  /**
   * Build a fulfillment transaction from order and listing database rows.
   * Witnesses attach only to payment escrow and NFT custody slips (never Bound).
   */
  createFulfillmentTransaction: function createFulfillmentTransaction(order_row) {
    var _arguments2 = arguments,
      _this4 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var _ref3, _order_row$price2;
      var listing_rows, listing_tx, buyer, buy_qty, allocated_total, primary_listing_row, buyer_template_json, payment_input, payment_access_script, payment_utxo_key, access_script_jobs, fulfillment_tx, partial_relists, _iterator3, _step3, _ref6, _listing_row2$take_qt, _listing_row2$quantit, _listing_row2, _take_qty3, _row_qty, listing_access_script, row_triple_json, listing_p2sh_public_key, j, slip_json, listing_utxo_key, listing_input, is_custody, remainder, buyer_custody_total, _iterator4, _step4, _ref7, _listing_row3$take_qt, _listing_row3$quantit, _row_triple_json$1$am, _row_triple_json$, _listing_row3, _take_qty4, _row_qty2, _row_triple_json, _row_custody, _partitionCustodyDepo2, _buyer2, buyer_out1, buyer_out2, buyer_out3, _i3, _partial_relists, relist, relist_out1, _relist$row_triple_js, _relist$row_triple_js2, _relist$listing_row$q, relist_out2, row_custody, row_qty, take_qty, _partitionCustodyDepo, remaining, relist_out3, unit_price, web3_ticker, web3_sale, seller_amounts, _order_row$payment_am, _this4$app$wallet$con, paid, fee_nolan, net, shares, total_take, _iterator5, _step5, _ref4, _listing_row$take_qty2, listing_row, seller, _take_qty, assigned, _iterator6, _step6, _ref5, _listing_row$take_qty3, _listing_row, _seller, _take_qty2, prior, _iterator7, _step7, _step7$value, _seller2, amount, seller_slip, outputs, i, auth_parts, _i4, _slip$amount, _slip$type, slip, pk_b58, pk_bytes, amount_buf, p2sh_auth_hash, access_scripts, _i5, _access_script_jobs, job, auth_message, p2sh_indexes, _listing_txmsg$listin, listing_txmsg, rental_nft, is_store_rental, _buyer, mutated, _t8, _t9, _t0, _t1, _t10, _t11;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            listing_rows = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : [];
            listing_tx = _arguments2.length > 2 && _arguments2[2] !== undefined ? _arguments2[2] : null;
            if (order_row) {
              _context4.n = 1;
              break;
            }
            throw new Error('order_row is required');
          case 1:
            if (listing_rows.length) {
              _context4.n = 2;
              break;
            }
            throw new Error('listing rows are required');
          case 2:
            buyer = order_row.buyer || '';
            buy_qty = Number(order_row.quantity) || 1;
            allocated_total = listing_rows.reduce(function (sum, row) {
              var _ref2, _row$take_qty;
              return sum + Number((_ref2 = (_row$take_qty = row.take_qty) !== null && _row$take_qty !== void 0 ? _row$take_qty : row.quantity) !== null && _ref2 !== void 0 ? _ref2 : 0);
            }, 0);
            if (!(buy_qty <= 0 || allocated_total !== buy_qty)) {
              _context4.n = 3;
              break;
            }
            throw new Error('invalid fulfillment quantity');
          case 3:
            primary_listing_row = listing_rows[0];
            buyer_template_json = listingInputSlipJsonFromRecord(primary_listing_row);
            if (buyer_template_json) {
              _context4.n = 4;
              break;
            }
            throw new Error('listing utxo slips not available');
          case 4:
            payment_input = paymentInputFromOrder(order_row);
            if (payment_input) {
              _context4.n = 5;
              break;
            }
            throw new Error('payment utxo slip not available');
          case 5:
            payment_access_script = order_row.access_script || '';
            if (payment_access_script) {
              _context4.n = 6;
              break;
            }
            throw new Error('payment access script not available on order');
          case 6:
            payment_utxo_key = String(payment_input.utxoKey || '');
            if (payment_utxo_key) {
              _context4.n = 7;
              break;
            }
            throw new Error('P2SH input is missing utxoset key');
          case 7:
            access_script_jobs = [];
            fulfillment_tx = new Transaction();
            fulfillment_tx.timestamp = Date.now();
            fulfillment_tx.type = TransactionType.Bound;
            fulfillment_tx.msg = {};
            fulfillment_tx.addFromSlip(payment_input);
            access_script_jobs.push({
              access_script: payment_access_script,
              message: payment_utxo_key,
              role: 'payment'
            });
            partial_relists = [];
            _iterator3 = _createForOfIteratorHelper(listing_rows);
            _context4.p = 8;
            _iterator3.s();
          case 9:
            if ((_step3 = _iterator3.n()).done) {
              _context4.n = 19;
              break;
            }
            _listing_row2 = _step3.value;
            _take_qty3 = Number((_ref6 = (_listing_row2$take_qt = _listing_row2.take_qty) !== null && _listing_row2$take_qt !== void 0 ? _listing_row2$take_qt : _listing_row2.quantity) !== null && _ref6 !== void 0 ? _ref6 : 0);
            _row_qty = Number((_listing_row2$quantit = _listing_row2.quantity) !== null && _listing_row2$quantit !== void 0 ? _listing_row2$quantit : 1);
            listing_access_script = _listing_row2.access_script || '';
            if (listing_access_script) {
              _context4.n = 10;
              break;
            }
            throw new Error('listing access script not available');
          case 10:
            if (!(_take_qty3 <= 0 || _take_qty3 > _row_qty)) {
              _context4.n = 11;
              break;
            }
            throw new Error('invalid fulfillment quantity');
          case 11:
            row_triple_json = listingInputSlipJsonFromRecord(_listing_row2);
            if (row_triple_json) {
              _context4.n = 12;
              break;
            }
            throw new Error('listing utxo slips not available');
          case 12:
            listing_p2sh_public_key = slipPublicKey(_this4.app, _listing_row2.p2sh_address) || _listing_row2.p2sh_address;
            j = 0;
          case 13:
            if (!(j < row_triple_json.length)) {
              _context4.n = 16;
              break;
            }
            slip_json = row_triple_json[j];
            listing_utxo_key = String((slip_json === null || slip_json === void 0 ? void 0 : slip_json.utxoKey) || '');
            listing_input = new Slip(undefined, slip_json);
            is_custody = j === 1;
            if (!(is_custody && !listing_utxo_key)) {
              _context4.n = 14;
              break;
            }
            throw new Error('P2SH input is missing utxoset key');
          case 14:
            fulfillment_tx.addFromSlip(listing_input);
            if (is_custody) {
              access_script_jobs.push({
                access_script: listing_access_script,
                message: listing_utxo_key,
                role: "listing-custody-".concat(_listing_row2.signature || listing_rows.indexOf(_listing_row2))
              });
            }
          case 15:
            j++;
            _context4.n = 13;
            break;
          case 16:
            remainder = _row_qty - _take_qty3;
            if (!(remainder > 0)) {
              _context4.n = 18;
              break;
            }
            if (!partial_relists.length) {
              _context4.n = 17;
              break;
            }
            throw new Error('multiple partial listing consumptions are not supported');
          case 17:
            partial_relists.push({
              listing_row: _listing_row2,
              row_triple_json: row_triple_json,
              listing_p2sh_public_key: listing_p2sh_public_key,
              remainder: remainder
            });
          case 18:
            _context4.n = 9;
            break;
          case 19:
            _context4.n = 21;
            break;
          case 20:
            _context4.p = 20;
            _t8 = _context4.v;
            _iterator3.e(_t8);
          case 21:
            _context4.p = 21;
            _iterator3.f();
            return _context4.f(21);
          case 22:
            buyer_custody_total = 0n;
            _iterator4 = _createForOfIteratorHelper(listing_rows);
            _context4.p = 23;
            _iterator4.s();
          case 24:
            if ((_step4 = _iterator4.n()).done) {
              _context4.n = 27;
              break;
            }
            _listing_row3 = _step4.value;
            _take_qty4 = Number((_ref7 = (_listing_row3$take_qt = _listing_row3.take_qty) !== null && _listing_row3$take_qt !== void 0 ? _listing_row3$take_qt : _listing_row3.quantity) !== null && _ref7 !== void 0 ? _ref7 : 0);
            _row_qty2 = Number((_listing_row3$quantit = _listing_row3.quantity) !== null && _listing_row3$quantit !== void 0 ? _listing_row3$quantit : 1);
            _row_triple_json = listingInputSlipJsonFromRecord(_listing_row3);
            if (!(!_row_triple_json || _row_qty2 <= 0 || _take_qty4 <= 0)) {
              _context4.n = 25;
              break;
            }
            return _context4.a(3, 26);
          case 25:
            _row_custody = BigInt((_row_triple_json$1$am = (_row_triple_json$ = _row_triple_json[1]) === null || _row_triple_json$ === void 0 ? void 0 : _row_triple_json$.amount) !== null && _row_triple_json$1$am !== void 0 ? _row_triple_json$1$am : 0);
            _partitionCustodyDepo2 = partitionCustodyDeposit(_row_custody, _take_qty4, _row_qty2), _buyer2 = _partitionCustodyDepo2.buyer;
            buyer_custody_total += _buyer2;
          case 26:
            _context4.n = 24;
            break;
          case 27:
            _context4.n = 29;
            break;
          case 28:
            _context4.p = 28;
            _t9 = _context4.v;
            _iterator4.e(_t9);
          case 29:
            _context4.p = 29;
            _iterator4.f();
            return _context4.f(29);
          case 30:
            buyer_out1 = new Slip(undefined, buyer_template_json[0]);
            buyer_out1.amount = BigInt(buy_qty);
            fulfillment_tx.addToSlip(buyer_out1);
            buyer_out2 = new Slip(undefined, buyer_template_json[1]);
            buyer_out2.publicKey = buyer;
            buyer_out2.amount = buyer_custody_total;
            fulfillment_tx.addToSlip(buyer_out2);
            buyer_out3 = new Slip(undefined, buyer_template_json[2]);
            fulfillment_tx.addToSlip(buyer_out3);
            for (_i3 = 0, _partial_relists = partial_relists; _i3 < _partial_relists.length; _i3++) {
              relist = _partial_relists[_i3];
              {
                relist_out1 = new Slip(undefined, relist.row_triple_json[0]);
                relist_out1.amount = BigInt(relist.remainder);
                fulfillment_tx.addToSlip(relist_out1);
              }
              {
                relist_out2 = new Slip(undefined, relist.row_triple_json[1]);
                relist_out2.publicKey = relist.listing_p2sh_public_key;
                row_custody = BigInt((_relist$row_triple_js = (_relist$row_triple_js2 = relist.row_triple_json[1]) === null || _relist$row_triple_js2 === void 0 ? void 0 : _relist$row_triple_js2.amount) !== null && _relist$row_triple_js !== void 0 ? _relist$row_triple_js : 0);
                row_qty = Number((_relist$listing_row$q = relist.listing_row.quantity) !== null && _relist$listing_row$q !== void 0 ? _relist$listing_row$q : 1);
                take_qty = row_qty - relist.remainder;
                _partitionCustodyDepo = partitionCustodyDeposit(row_custody, take_qty, row_qty), remaining = _partitionCustodyDepo.remaining;
                relist_out2.amount = remaining;
                fulfillment_tx.addToSlip(relist_out2);
              }
              {
                relist_out3 = new Slip(undefined, relist.row_triple_json[2]);
                fulfillment_tx.addToSlip(relist_out3);
              }
            }
            unit_price = BigInt((_ref3 = (_order_row$price2 = order_row.price) !== null && _order_row$price2 !== void 0 ? _order_row$price2 : primary_listing_row.price) !== null && _ref3 !== void 0 ? _ref3 : 0);
            web3_ticker = String(primary_listing_row.web3_ticker || '').trim().toUpperCase();
            web3_sale = web3_ticker !== '' && web3_ticker !== 'SAITO';
            seller_amounts = new Map();
            if (!web3_sale) {
              _context4.n = 39;
              break;
            }
            paid = BigInt((_order_row$payment_am = order_row.payment_amount) !== null && _order_row$payment_am !== void 0 ? _order_row$payment_am : 0);
            fee_nolan = BigInt((_this4$app$wallet$con = _this4.app.wallet.convertSaitoToNolan(_this4.fee || 0)) !== null && _this4$app$wallet$con !== void 0 ? _this4$app$wallet$con : 0);
            net = paid > fee_nolan ? paid - fee_nolan : 0n;
            shares = [];
            total_take = 0;
            _iterator5 = _createForOfIteratorHelper(listing_rows);
            _context4.p = 31;
            _iterator5.s();
          case 32:
            if ((_step5 = _iterator5.n()).done) {
              _context4.n = 35;
              break;
            }
            listing_row = _step5.value;
            seller = listing_row.seller || '';
            _take_qty = Number((_ref4 = (_listing_row$take_qty2 = listing_row.take_qty) !== null && _listing_row$take_qty2 !== void 0 ? _listing_row$take_qty2 : listing_row.quantity) !== null && _ref4 !== void 0 ? _ref4 : 0);
            if (!(!seller || _take_qty <= 0)) {
              _context4.n = 33;
              break;
            }
            return _context4.a(3, 34);
          case 33:
            shares.push({
              seller: seller,
              take_qty: _take_qty
            });
            total_take += _take_qty;
          case 34:
            _context4.n = 32;
            break;
          case 35:
            _context4.n = 37;
            break;
          case 36:
            _context4.p = 36;
            _t0 = _context4.v;
            _iterator5.e(_t0);
          case 37:
            _context4.p = 37;
            _iterator5.f();
            return _context4.f(37);
          case 38:
            assigned = 0n;
            shares.forEach(function (share, index) {
              var amount = index === shares.length - 1 || total_take <= 0 ? net - assigned : net * BigInt(share.take_qty) / BigInt(total_take);
              assigned += amount;
              var prior = seller_amounts.get(share.seller) || 0n;
              seller_amounts.set(share.seller, prior + amount);
            });
            _context4.n = 47;
            break;
          case 39:
            _iterator6 = _createForOfIteratorHelper(listing_rows);
            _context4.p = 40;
            _iterator6.s();
          case 41:
            if ((_step6 = _iterator6.n()).done) {
              _context4.n = 44;
              break;
            }
            _listing_row = _step6.value;
            _seller = _listing_row.seller || '';
            if (_seller) {
              _context4.n = 42;
              break;
            }
            return _context4.a(3, 43);
          case 42:
            _take_qty2 = Number((_ref5 = (_listing_row$take_qty3 = _listing_row.take_qty) !== null && _listing_row$take_qty3 !== void 0 ? _listing_row$take_qty3 : _listing_row.quantity) !== null && _ref5 !== void 0 ? _ref5 : 0);
            prior = seller_amounts.get(_seller) || 0n;
            seller_amounts.set(_seller, prior + unit_price * BigInt(_take_qty2));
          case 43:
            _context4.n = 41;
            break;
          case 44:
            _context4.n = 46;
            break;
          case 45:
            _context4.p = 45;
            _t1 = _context4.v;
            _iterator6.e(_t1);
          case 46:
            _context4.p = 46;
            _iterator6.f();
            return _context4.f(46);
          case 47:
            _iterator7 = _createForOfIteratorHelper(seller_amounts.entries());
            _context4.p = 48;
            _iterator7.s();
          case 49:
            if ((_step7 = _iterator7.n()).done) {
              _context4.n = 52;
              break;
            }
            _step7$value = _slicedToArray(_step7.value, 2), _seller2 = _step7$value[0], amount = _step7$value[1];
            if (!(amount <= 0n)) {
              _context4.n = 50;
              break;
            }
            return _context4.a(3, 51);
          case 50:
            seller_slip = new Slip();
            seller_slip.publicKey = _seller2;
            seller_slip.amount = amount;
            seller_slip.type = SlipType.Normal;
            fulfillment_tx.addToSlip(seller_slip);
          case 51:
            _context4.n = 49;
            break;
          case 52:
            _context4.n = 54;
            break;
          case 53:
            _context4.p = 53;
            _t10 = _context4.v;
            _iterator7.e(_t10);
          case 54:
            _context4.p = 54;
            _iterator7.f();
            return _context4.f(54);
          case 55:
            // Finalize output slip indices the same way Transaction::sign does.
            outputs = fulfillment_tx.to || [];
            for (i = 0; i < outputs.length; i++) {
              outputs[i].index = i;
            }

            // Blake3 over concat(serialize_output_for_signature) for every output.
            // Spec: saito-core get_p2sh_auth_hash / Slip::serialize_output_for_signature —
            //   public_key || amount_be_u64 || slip_index_u8 || slip_type_u8
            auth_parts = [];
            _i4 = 0;
          case 56:
            if (!(_i4 < outputs.length)) {
              _context4.n = 59;
              break;
            }
            slip = outputs[_i4];
            pk_b58 = String((slip === null || slip === void 0 ? void 0 : slip.publicKey) || '');
            if (pk_b58) {
              _context4.n = 57;
              break;
            }
            throw new Error('fulfillment output is missing a public key');
          case 57:
            pk_bytes = Buffer.from(_this4.app.crypto.fromBase58(pk_b58), 'hex');
            amount_buf = Buffer.alloc(8);
            amount_buf.writeBigUInt64BE(BigInt((_slip$amount = slip === null || slip === void 0 ? void 0 : slip.amount) !== null && _slip$amount !== void 0 ? _slip$amount : 0));
            auth_parts.push(pk_bytes);
            auth_parts.push(amount_buf);
            auth_parts.push(Buffer.from([Number(slip.index) & 0xff]));
            auth_parts.push(Buffer.from([Number((_slip$type = slip.type) !== null && _slip$type !== void 0 ? _slip$type : 0) & 0xff]));
          case 58:
            _i4++;
            _context4.n = 56;
            break;
          case 59:
            p2sh_auth_hash = String(_this4.app.crypto.hash(Buffer.concat(auth_parts))); // CHECKMULTISIG verifies signatures over: utxoset_key|p2sh_auth_hash
            access_scripts = [];
            _i5 = 0, _access_script_jobs = access_script_jobs;
          case 60:
            if (!(_i5 < _access_script_jobs.length)) {
              _context4.n = 63;
              break;
            }
            job = _access_script_jobs[_i5];
            auth_message = "".concat(job.message, "|").concat(p2sh_auth_hash);
            _t11 = access_scripts;
            _context4.n = 61;
            return signAccessScriptWitness(_this4.app, job.access_script, auth_message);
          case 61:
            _t11.push.call(_t11, _context4.v);
          case 62:
            _i5++;
            _context4.n = 60;
            break;
          case 63:
            fulfillment_tx.msg.access_scripts = access_scripts;
            p2sh_indexes = listRustP2shInputIndexes(_this4.app, fulfillment_tx);
            if (!(access_scripts.length !== p2sh_indexes.length)) {
              _context4.n = 64;
              break;
            }
            throw new Error("access script count ".concat(access_scripts.length, " does not match P2SH input count ").concat(p2sh_indexes.length));
          case 64:
            if (listing_tx) {
              _this4.attachFulfillmentTxmsg(fulfillment_tx, order_row, listing_rows, listing_tx);
            }

            // Store → renter: append hop with delegated = 0 via the same transfer hook.
            // Does not create a second transaction; mutates fulfillment_tx before sign.
            if (!listing_tx) {
              _context4.n = 66;
              break;
            }
            listing_txmsg = listingTxmsg(listing_tx);
            rental_nft = new SaitoNFT(_this4.app, _this4, listing_tx, null);
            is_store_rental = typeof rental_nft.returnType === 'function' && rental_nft.returnType() === 'store-nft-rental' || String((listing_txmsg === null || listing_txmsg === void 0 || (_listing_txmsg$listin = listing_txmsg.listing) === null || _listing_txmsg$listin === void 0 ? void 0 : _listing_txmsg$listin.listing_mode) || '').toLowerCase() === 'rent';
            if (!is_store_rental) {
              _context4.n = 66;
              break;
            }
            // Ensure hook class match even if slip type parsing fell back to "image".
            rental_nft.nft_type = 'store-nft-rental';
            _buyer = String((order_row === null || order_row === void 0 ? void 0 : order_row.buyer) || '').trim();
            _context4.n = 65;
            return rental_nft.modifyBeforeSend(fulfillment_tx, _buyer);
          case 65:
            mutated = _context4.v;
            if (mutated) {
              _context4.n = 66;
              break;
            }
            throw new Error('store-nft-rental fulfillment transfer hop blocked');
          case 66:
            _context4.n = 67;
            return fulfillment_tx.sign();
          case 67:
            return _context4.a(2, fulfillment_tx);
        }
      }, _callee4, null, [[48, 53, 54, 55], [40, 45, 46, 47], [31, 36, 37, 38], [23, 28, 29, 30], [8, 20, 21, 22]]);
    }))();
  },
  /**
   * Seller reclaim: spend the listing NFT P2SH triple back to the seller wallet.
   * listing_row must include utxo_slip1/2/3 + access_script (from Store DB / peer).
   * listing_tx (Archive) supplies NFT txmsg payload (data/image/etc.) and rental hops.
   */
  createDelistAssetTransaction: function createDelistAssetTransaction(listing_row) {
    var _arguments3 = arguments,
      _this5 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var _listing_row$quantity2, _row_triple_json$2, _nft_msg$listing;
      var listing_tx, seller, my_key, row_qty, listing_access_script, row_triple_json, custody_utxo_key, delist_tx, j, _row_triple_json$0$am, _row_triple_json$3, out1, _row_triple_json$1$am2, _row_triple_json$4, out2, outputs, i, auth_parts, _i6, _slip$amount2, _slip$type2, slip, pk_b58, pk_bytes, amount_buf, p2sh_auth_hash, auth_message, access_scripts, p2sh_indexes, listing_txmsg, nft_msg, _listing_txmsg$listin2, rental_nft, is_store_rental, _delist_tx$msg$listin, mutated, _t12, _t13;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            listing_tx = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : null;
            if (listing_row !== null && listing_row !== void 0 && listing_row.signature) {
              _context5.n = 1;
              break;
            }
            throw new Error('listing row is required');
          case 1:
            _t12 = String(listing_row.seller || '').trim();
            if (_t12) {
              _context5.n = 3;
              break;
            }
            _context5.n = 2;
            return _this5.app.wallet.getPublicKey();
          case 2:
            _t12 = _context5.v;
          case 3:
            seller = _t12;
            _context5.n = 4;
            return _this5.app.wallet.getPublicKey();
          case 4:
            my_key = _context5.v;
            if (!(!seller || seller !== my_key)) {
              _context5.n = 5;
              break;
            }
            throw new Error('only the listing seller can delist');
          case 5:
            row_qty = Number((_listing_row$quantity2 = listing_row.quantity) !== null && _listing_row$quantity2 !== void 0 ? _listing_row$quantity2 : 1);
            if (!(row_qty <= 0)) {
              _context5.n = 6;
              break;
            }
            throw new Error('invalid listing quantity');
          case 6:
            listing_access_script = listing_row.access_script || '';
            if (listing_access_script) {
              _context5.n = 7;
              break;
            }
            throw new Error('listing access script not available');
          case 7:
            row_triple_json = listingInputSlipJsonFromRecord(listing_row);
            if (row_triple_json) {
              _context5.n = 8;
              break;
            }
            throw new Error('listing utxo slips not available');
          case 8:
            custody_utxo_key = String(((_row_triple_json$2 = row_triple_json[1]) === null || _row_triple_json$2 === void 0 ? void 0 : _row_triple_json$2.utxoKey) || '');
            if (custody_utxo_key) {
              _context5.n = 9;
              break;
            }
            throw new Error('P2SH input is missing utxoset key');
          case 9:
            delist_tx = new Transaction();
            delist_tx.timestamp = Date.now();
            delist_tx.type = TransactionType.Bound;
            delist_tx.msg = {};
            for (j = 0; j < row_triple_json.length; j++) {
              delist_tx.addFromSlip(new Slip(undefined, row_triple_json[j]));
            }
            out1 = new Slip(undefined, row_triple_json[0]);
            out1.amount = BigInt((_row_triple_json$0$am = (_row_triple_json$3 = row_triple_json[0]) === null || _row_triple_json$3 === void 0 ? void 0 : _row_triple_json$3.amount) !== null && _row_triple_json$0$am !== void 0 ? _row_triple_json$0$am : row_qty);
            delist_tx.addToSlip(out1);
            out2 = new Slip(undefined, row_triple_json[1]);
            out2.publicKey = seller;
            out2.amount = BigInt((_row_triple_json$1$am2 = (_row_triple_json$4 = row_triple_json[1]) === null || _row_triple_json$4 === void 0 ? void 0 : _row_triple_json$4.amount) !== null && _row_triple_json$1$am2 !== void 0 ? _row_triple_json$1$am2 : 0);
            delist_tx.addToSlip(out2);
            delist_tx.addToSlip(new Slip(undefined, row_triple_json[2]));
            outputs = delist_tx.to || [];
            for (i = 0; i < outputs.length; i++) {
              outputs[i].index = i;
            }
            auth_parts = [];
            _i6 = 0;
          case 10:
            if (!(_i6 < outputs.length)) {
              _context5.n = 13;
              break;
            }
            slip = outputs[_i6];
            pk_b58 = String((slip === null || slip === void 0 ? void 0 : slip.publicKey) || '');
            if (pk_b58) {
              _context5.n = 11;
              break;
            }
            throw new Error('delist output is missing a public key');
          case 11:
            pk_bytes = Buffer.from(_this5.app.crypto.fromBase58(pk_b58), 'hex');
            amount_buf = Buffer.alloc(8);
            amount_buf.writeBigUInt64BE(BigInt((_slip$amount2 = slip === null || slip === void 0 ? void 0 : slip.amount) !== null && _slip$amount2 !== void 0 ? _slip$amount2 : 0));
            auth_parts.push(pk_bytes);
            auth_parts.push(amount_buf);
            auth_parts.push(Buffer.from([Number(slip.index) & 0xff]));
            auth_parts.push(Buffer.from([Number((_slip$type2 = slip.type) !== null && _slip$type2 !== void 0 ? _slip$type2 : 0) & 0xff]));
          case 12:
            _i6++;
            _context5.n = 10;
            break;
          case 13:
            p2sh_auth_hash = String(_this5.app.crypto.hash(Buffer.concat(auth_parts)));
            auth_message = "".concat(custody_utxo_key, "|").concat(p2sh_auth_hash);
            _context5.n = 14;
            return signAccessScriptWitness(_this5.app, listing_access_script, auth_message);
          case 14:
            _t13 = _context5.v;
            access_scripts = [_t13];
            p2sh_indexes = listRustP2shInputIndexes(_this5.app, delist_tx);
            if (!(access_scripts.length !== p2sh_indexes.length)) {
              _context5.n = 15;
              break;
            }
            throw new Error("access script count ".concat(access_scripts.length, " does not match P2SH input count ").concat(p2sh_indexes.length));
          case 15:
            // Carry NFT payload forward (data/image/title/etc.) like list-asset / fulfillment.
            listing_txmsg = listing_tx ? listingTxmsg(listing_tx) : {};
            nft_msg = JSON.parse(JSON.stringify(listing_txmsg || {}));
            delete nft_msg.request;
            delete nft_msg.access_scripts;
            delete nft_msg.fulfill_sale;
            delete nft_msg.listing_signature;
            delist_tx.msg = _objectSpread(_objectSpread({}, nft_msg), {}, {
              module: 'Store',
              request: 'delist-asset',
              listing_signature: listing_row.signature,
              seller: seller,
              nft_id: listing_row.nft_id || nft_msg.nft_id || ((_nft_msg$listing = nft_msg.listing) === null || _nft_msg$listing === void 0 ? void 0 : _nft_msg$listing.nft_id) || '',
              quantity: row_qty,
              access_script: listing_access_script,
              access_hash: listing_row.access_hash || '',
              p2sh_address: listing_row.p2sh_address || '',
              access_scripts: access_scripts
            });
            if (!listing_tx) {
              _context5.n = 18;
              break;
            }
            rental_nft = new SaitoNFT(_this5.app, _this5, listing_tx, null);
            is_store_rental = typeof rental_nft.returnType === 'function' && rental_nft.returnType() === 'store-nft-rental' || String((listing_txmsg === null || listing_txmsg === void 0 || (_listing_txmsg$listin2 = listing_txmsg.listing) === null || _listing_txmsg$listin2 === void 0 ? void 0 : _listing_txmsg$listin2.listing_mode) || '').toLowerCase() === 'rent';
            if (!is_store_rental) {
              _context5.n = 18;
              break;
            }
            rental_nft.nft_type = 'store-nft-rental';
            _context5.n = 16;
            return rental_nft.modifyBeforeSend(delist_tx, seller);
          case 16:
            mutated = _context5.v;
            if (mutated) {
              _context5.n = 17;
              break;
            }
            throw new Error('store-nft-rental delist transfer hop blocked');
          case 17:
            // Keep delist control fields after hop mutation; preserve NFT data payload.
            delist_tx.msg = delist_tx.msg || {};
            delist_tx.msg.module = 'Store';
            delist_tx.msg.request = 'delist-asset';
            delist_tx.msg.listing_signature = listing_row.signature;
            delist_tx.msg.seller = seller;
            delist_tx.msg.nft_id = listing_row.nft_id || delist_tx.msg.nft_id || ((_delist_tx$msg$listin = delist_tx.msg.listing) === null || _delist_tx$msg$listin === void 0 ? void 0 : _delist_tx$msg$listin.nft_id) || '';
            delist_tx.msg.quantity = row_qty;
            delist_tx.msg.access_script = listing_access_script;
            delist_tx.msg.access_hash = listing_row.access_hash || '';
            delist_tx.msg.p2sh_address = listing_row.p2sh_address || '';
            delist_tx.msg.access_scripts = access_scripts;
          case 18:
            _context5.n = 19;
            return delist_tx.sign();
          case 19:
            return _context5.a(2, delist_tx);
        }
      }, _callee5);
    }))();
  },
  receiveDelistAssetTransaction: function receiveDelistAssetTransaction(blk, tx) {
    var _this6 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
      var _tx$returnMessage;
      var txmsg, spent_rows, created_tuples, _iterator8, _step8, _loop, _ret, _t14, _t15;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            console.log('Store: receiveDelistAssetTransaction start', tx === null || tx === void 0 ? void 0 : tx.signature);
            txmsg = (tx === null || tx === void 0 || (_tx$returnMessage = tx.returnMessage) === null || _tx$returnMessage === void 0 ? void 0 : _tx$returnMessage.call(tx)) || {};
            if (!(txmsg.module !== 'Store' || txmsg.request !== 'delist-asset')) {
              _context7.n = 1;
              break;
            }
            return _context7.a(2);
          case 1:
            if (!_this6.app.BROWSER) {
              _context7.n = 2;
              break;
            }
            _this6.app.connection.emit('store-delist-asset', {
              blk: blk,
              tx: tx,
              conf: 0
            });
            return _context7.a(2);
          case 2:
            _context7.p = 2;
            _context7.n = 3;
            return _this6.warehouse.matchSpentListings(tx);
          case 3:
            spent_rows = _context7.v;
            if (spent_rows.length) {
              _context7.n = 4;
              break;
            }
            console.warn('Store: delist matched no active listing', tx.signature);
            return _context7.a(2);
          case 4:
            created_tuples = returnCreatedNftTuples(tx);
            _iterator8 = _createForOfIteratorHelper(spent_rows);
            _context7.p = 5;
            _loop = /*#__PURE__*/_regenerator().m(function _loop() {
              var row, seller, returned_to_seller;
              return _regenerator().w(function (_context6) {
                while (1) switch (_context6.n) {
                  case 0:
                    row = _step8.value;
                    seller = String(row.seller || '').trim();
                    if (seller) {
                      _context6.n = 1;
                      break;
                    }
                    console.warn('Store: delist listing missing seller', row.signature);
                    return _context6.a(2, 0);
                  case 1:
                    returned_to_seller = created_tuples.some(function (tuple) {
                      return tuple.custody_public_key === seller;
                    });
                    if (returned_to_seller) {
                      _context6.n = 2;
                      break;
                    }
                    console.warn('Store: delist custody not returned to seller; skipping', row.signature, seller);
                    return _context6.a(2, 0);
                  case 2:
                    if (txmsg.listing_signature && String(txmsg.listing_signature) !== String(row.signature)) {
                      console.warn('Store: delist listing_signature mismatch; consuming slip-matched row', txmsg.listing_signature, row.signature);
                    }
                    _context6.n = 3;
                    return _this6.warehouse.consumeDelistedListing(row, tx, blk);
                  case 3:
                    return _context6.a(2);
                }
              }, _loop);
            });
            _iterator8.s();
          case 6:
            if ((_step8 = _iterator8.n()).done) {
              _context7.n = 9;
              break;
            }
            return _context7.d(_regeneratorValues(_loop()), 7);
          case 7:
            _ret = _context7.v;
            if (!(_ret === 0)) {
              _context7.n = 8;
              break;
            }
            return _context7.a(3, 8);
          case 8:
            _context7.n = 6;
            break;
          case 9:
            _context7.n = 11;
            break;
          case 10:
            _context7.p = 10;
            _t14 = _context7.v;
            _iterator8.e(_t14);
          case 11:
            _context7.p = 11;
            _iterator8.f();
            return _context7.f(11);
          case 12:
            _context7.n = 14;
            break;
          case 13:
            _context7.p = 13;
            _t15 = _context7.v;
            console.error('Store: receiveDelistAssetTransaction failed', _t15);
            if (_t15 !== null && _t15 !== void 0 && _t15.stack) {
              console.error(_t15.stack);
            }
          case 14:
            return _context7.a(2);
        }
      }, _callee6, null, [[5, 10, 11, 12], [2, 13]]);
    }))();
  },
  createPurchaseAssetTransaction: function createPurchaseAssetTransaction(summary) {
    var _arguments4 = arguments,
      _this7 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      var _summary$price;
      var sale, nolan_to_send, web3_ticker, web3_amount, web3_sale, bucket_price, buyer_publickey, script_info, payment_recipient, unfunded, newtx, note, seller_publickey, buyer_privatekey, shared_secret, ciphertext, _t16;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.n) {
          case 0:
            sale = _arguments4.length > 1 && _arguments4[1] !== undefined ? _arguments4[1] : {};
            nolan_to_send = _arguments4.length > 2 && _arguments4[2] !== undefined ? _arguments4[2] : 0n;
            if (_this7.store_public_key) {
              _context8.n = 1;
              break;
            }
            throw new Error('Store public key is not configured');
          case 1:
            if (summary !== null && summary !== void 0 && summary.nft_id) {
              _context8.n = 2;
              break;
            }
            throw new Error('Summary nft_id is required for purchase');
          case 2:
            web3_ticker = String(summary.web3_ticker || '').trim().toUpperCase();
            web3_amount = String(summary.web3_amount || '').trim();
            web3_sale = web3_ticker !== '' && web3_ticker !== 'SAITO';
            bucket_price = Number((_summary$price = summary.price) !== null && _summary$price !== void 0 ? _summary$price : 0);
            if (!web3_sale) {
              _context8.n = 4;
              break;
            }
            if (Number(web3_amount) > 0) {
              _context8.n = 3;
              break;
            }
            throw new Error('Web3 price is required for purchase');
          case 3:
            _context8.n = 5;
            break;
          case 4:
            if (!(!Number.isFinite(bucket_price) || bucket_price <= 0)) {
              _context8.n = 5;
              break;
            }
            throw new Error('Summary price is required for purchase');
          case 5:
            _context8.n = 6;
            return _this7.app.wallet.getPublicKey();
          case 6:
            buyer_publickey = _context8.v;
            script_info = createPurchaseScript(_this7.app, {
              buyer_publickey: buyer_publickey,
              store_publickey: _this7.store_public_key
            });
            payment_recipient = p2shPaymentRecipient(_this7.app, script_info.p2sh_address, 'createPurchaseAssetTransaction'); // A buyer without spendable SAITO still needs this purchase message. BuySaito
            // copies it onto its own payment, so the carrier itself sends nothing.
            // A web3 sale is the same kind of carrier: the crypto deposit is what gets paid.
            unfunded = web3_sale || sale.unfunded === true;
            if (!unfunded) {
              _context8.n = 8;
              break;
            }
            _context8.n = 7;
            return _this7.app.wallet.createUnsignedTransactionWithDefaultFee(payment_recipient, 0n, 0n);
          case 7:
            _t16 = _context8.v;
            _context8.n = 10;
            break;
          case 8:
            _context8.n = 9;
            return _this7.app.wallet.createUnsignedTransactionWithDefaultFee(payment_recipient, nolan_to_send);
          case 9:
            _t16 = _context8.v;
          case 10:
            newtx = _t16;
            newtx.msg = {
              module: 'Store',
              request: 'purchase-asset',
              buyer: buyer_publickey,
              refund: buyer_publickey,
              nft_id: summary.nft_id,
              quantity: Number(sale.quantity) || 1,
              price: web3_sale ? '0' : String(sale.price),
              fee: String(sale.fee),
              access_script: script_info.access_script,
              access_hash: script_info.access_hash,
              p2sh_address: script_info.p2sh_address
            };
            if (web3_sale) {
              newtx.msg.web3_ticker = web3_ticker;
              newtx.msg.web3_amount = web3_amount;
            }
            note = String(sale.note || '').trim();
            if (!note) {
              _context8.n = 15;
              break;
            }
            seller_publickey = String(summary.seller || '').trim();
            if (seller_publickey) {
              _context8.n = 11;
              break;
            }
            throw new Error('Seller public key is unavailable; cannot encrypt note');
          case 11:
            _context8.n = 12;
            return _this7.app.wallet.getPrivateKey();
          case 12:
            buyer_privatekey = _context8.v;
            if (buyer_privatekey) {
              _context8.n = 13;
              break;
            }
            throw new Error('Wallet private key is unavailable; cannot encrypt note');
          case 13:
            shared_secret = _this7.app.crypto.generateSharedSecret(buyer_privatekey, seller_publickey);
            ciphertext = _this7.app.crypto.aesEncrypt(note, shared_secret);
            if (!(!ciphertext || typeof ciphertext !== 'string' || ciphertext === note)) {
              _context8.n = 14;
              break;
            }
            throw new Error('Failed to encrypt note to seller');
          case 14:
            newtx.msg.note = ciphertext;
          case 15:
            _context8.n = 16;
            return newtx.sign();
          case 16:
            return _context8.a(2, newtx);
        }
      }, _callee7);
    }))();
  },
  orderFromPurchaseTx: function orderFromPurchaseTx(tx, txmsg, payment_utxo) {
    var _tx$from, _tx$to;
    var _ref8 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref8$received_block_ = _ref8.received_block_id,
      received_block_id = _ref8$received_block_ === void 0 ? 0 : _ref8$received_block_,
      _ref8$received_block_2 = _ref8.received_block_hash,
      received_block_hash = _ref8$received_block_2 === void 0 ? '' : _ref8$received_block_2,
      _ref8$received_transa = _ref8.received_transaction_id,
      received_transaction_id = _ref8$received_transa === void 0 ? 0 : _ref8$received_transa;
    var web3_purchase = isWeb3PurchaseMessage(txmsg);
    var buyer = web3_purchase ? web3RefundRecipient(this.app, txmsg) : txmsg.buyer || ((_tx$from = tx.from) === null || _tx$from === void 0 || (_tx$from = _tx$from[0]) === null || _tx$from === void 0 ? void 0 : _tx$from.publicKey) || '';
    if (web3_purchase && !buyer) {
      throw new Error('Store purchase refund recipient is missing');
    }
    var payment_slip = (_tx$to = tx.to) === null || _tx$to === void 0 ? void 0 : _tx$to[payment_utxo.payment_output_index];
    var identifiers = web3_purchase ? storePaymentIdentifiers(txmsg) : {
      inbound_payment_uuid: '',
      transfer_uuid: ''
    };
    return new Order({
      order_tx_sig: tx.signature,
      buyer: buyer,
      note: String(txmsg.note || ''),
      inbound_payment_uuid: identifiers.inbound_payment_uuid,
      transfer_uuid: identifiers.transfer_uuid,
      payment_tx_sig: payment_utxo.payment_tx_sig,
      payment_output_index: payment_utxo.payment_output_index,
      payment_amount: Number(payment_utxo.payment_amount),
      utxo_slip: payment_slip ? serializeSlip(payment_slip) : '',
      access_hash: txmsg.access_hash || '',
      access_script: payment_utxo.access_script || txmsg.access_script || '',
      p2sh_address: payment_utxo.p2sh_address || txmsg.p2sh_address || '',
      block_id_received: Number(received_block_id !== null && received_block_id !== void 0 ? received_block_id : 0),
      block_hash_received: String(received_block_hash || ''),
      transaction_id_received: Number(received_transaction_id !== null && received_transaction_id !== void 0 ? received_transaction_id : 0),
      longest_chain_received: 1
    });
  },
  createOrderRefundTransaction: function createOrderRefundTransaction() {
    var _arguments5 = arguments,
      _this8 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
      var _ref0, _order$payment_amount, _order$payment_output, _order$payment_amount2;
      var _ref9, order_row, _ref9$refund_public_k, refund_public_key, _ref9$reason, reason, order, payment_input, payment_access_script, refund_to, amount, tx, refund_slip, refund_outputs, i, refund_auth_parts, _i7, _slip$amount3, _slip$type3, slip, pk_b58, pk_bytes, amount_buf, refund_p2sh_auth_hash, payment_utxo_key, refund_auth_message, _t17;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.n) {
          case 0:
            _ref9 = _arguments5.length > 0 && _arguments5[0] !== undefined ? _arguments5[0] : {}, order_row = _ref9.order_row, _ref9$refund_public_k = _ref9.refund_public_key, refund_public_key = _ref9$refund_public_k === void 0 ? '' : _ref9$refund_public_k, _ref9$reason = _ref9.reason, reason = _ref9$reason === void 0 ? 'unable-to-fulfill' : _ref9$reason;
            order = order_row;
            if (order) {
              _context9.n = 1;
              break;
            }
            return _context9.a(2, null);
          case 1:
            payment_input = paymentInputFromOrder(order);
            if (payment_input) {
              _context9.n = 2;
              break;
            }
            throw new Error('payment input not available');
          case 2:
            payment_access_script = order.access_script || '';
            if (payment_access_script) {
              _context9.n = 3;
              break;
            }
            throw new Error('payment access script not available on order');
          case 3:
            refund_to = refund_public_key || order.buyer || '';
            if (refund_to) {
              _context9.n = 4;
              break;
            }
            throw new Error('refund recipient not available');
          case 4:
            amount = BigInt((_ref0 = (_order$payment_amount = order.payment_amount) !== null && _order$payment_amount !== void 0 ? _order$payment_amount : payment_input.amount) !== null && _ref0 !== void 0 ? _ref0 : 0);
            if (!(amount <= 0n)) {
              _context9.n = 5;
              break;
            }
            throw new Error('refund amount not available');
          case 5:
            tx = new Transaction();
            tx.timestamp = Date.now();
            tx.addFromSlip(payment_input);
            refund_slip = new Slip();
            refund_slip.publicKey = refund_to;
            refund_slip.amount = amount;
            refund_slip.type = SlipType.Normal;
            tx.addToSlip(refund_slip);
            tx.msg = {
              module: 'Store',
              request: 'order-refund',
              type: 'order-refund',
              order_tx_sig: order.order_tx_sig || order.signature || '',
              buyer: order.buyer || '',
              refund: refund_to,
              reason: reason,
              payment_tx_sig: order.payment_tx_sig || order.order_tx_sig || '',
              payment_output_index: Number((_order$payment_output = order.payment_output_index) !== null && _order$payment_output !== void 0 ? _order$payment_output : 0),
              payment_amount: String((_order$payment_amount2 = order.payment_amount) !== null && _order$payment_amount2 !== void 0 ? _order$payment_amount2 : 0)
            };

            // Finalize output slip indices the same way Transaction::sign does.
            refund_outputs = tx.to || [];
            for (i = 0; i < refund_outputs.length; i++) {
              refund_outputs[i].index = i;
            }

            // Blake3 over concat(serialize_output_for_signature) for every output.
            // Spec: saito-core get_p2sh_auth_hash / Slip::serialize_output_for_signature —
            //   public_key || amount_be_u64 || slip_index_u8 || slip_type_u8
            refund_auth_parts = [];
            _i7 = 0;
          case 6:
            if (!(_i7 < refund_outputs.length)) {
              _context9.n = 9;
              break;
            }
            slip = refund_outputs[_i7];
            pk_b58 = String((slip === null || slip === void 0 ? void 0 : slip.publicKey) || '');
            if (pk_b58) {
              _context9.n = 7;
              break;
            }
            throw new Error('refund output is missing a public key');
          case 7:
            pk_bytes = Buffer.from(_this8.app.crypto.fromBase58(pk_b58), 'hex');
            amount_buf = Buffer.alloc(8);
            amount_buf.writeBigUInt64BE(BigInt((_slip$amount3 = slip === null || slip === void 0 ? void 0 : slip.amount) !== null && _slip$amount3 !== void 0 ? _slip$amount3 : 0));
            refund_auth_parts.push(pk_bytes);
            refund_auth_parts.push(amount_buf);
            refund_auth_parts.push(Buffer.from([Number(slip.index) & 0xff]));
            refund_auth_parts.push(Buffer.from([Number((_slip$type3 = slip.type) !== null && _slip$type3 !== void 0 ? _slip$type3 : 0) & 0xff]));
          case 8:
            _i7++;
            _context9.n = 6;
            break;
          case 9:
            refund_p2sh_auth_hash = String(_this8.app.crypto.hash(Buffer.concat(refund_auth_parts)));
            payment_utxo_key = String(payment_input.utxoKey || '');
            if (payment_utxo_key) {
              _context9.n = 10;
              break;
            }
            throw new Error('P2SH input is missing utxoset key');
          case 10:
            refund_auth_message = "".concat(payment_utxo_key, "|").concat(refund_p2sh_auth_hash);
            _context9.n = 11;
            return signAccessScriptWitness(_this8.app, payment_access_script, refund_auth_message);
          case 11:
            _t17 = _context9.v;
            tx.msg.access_scripts = [_t17];
            return _context9.a(2, tx);
        }
      }, _callee8);
    }))();
  },
  propagateOrderRefund: function propagateOrderRefund(order) {
    var _arguments6 = arguments,
      _this9 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
      var _ref1, _ref1$refund_public_k, refund_public_key, _ref1$reason, reason;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.n) {
          case 0:
            _ref1 = _arguments6.length > 1 && _arguments6[1] !== undefined ? _arguments6[1] : {}, _ref1$refund_public_k = _ref1.refund_public_key, refund_public_key = _ref1$refund_public_k === void 0 ? '' : _ref1$refund_public_k, _ref1$reason = _ref1.reason, reason = _ref1$reason === void 0 ? 'unable-to-fulfill' : _ref1$reason;
            if (!_this9.app.BROWSER) {
              _context0.n = 1;
              break;
            }
            return _context0.a(2);
          case 1:
            return _context0.a(2, _this9.warehouse.refunds.issue(order, {
              refund_public_key: refund_public_key,
              reason: reason
            }));
        }
      }, _callee9);
    }))();
  },
  receivePurchaseAssetTransaction: function receivePurchaseAssetTransaction(blk, tx) {
    var _this0 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
      var _tx$returnMessage2, _tx$from2, _this0$app$wallet$con, _this0$app$wallet$con2, _blk$id, _blk$hash;
      var txmsg, web3_purchase, web3_refund_recipient, buyer, nft_id, quantity, unit_price, fee, total, received_block_id, received_block_hash, received_transaction_id, refund_public_key, amount_paid, payment_utxo, refund_order, refund, processors, sender, summary, available, listing_ticker, listing_amount, message_amount, message_ticker, now, _summary$price2, order, _t19, _t20;
      return _regenerator().w(function (_context10) {
        while (1) switch (_context10.p = _context10.n) {
          case 0:
            if (!_this0.app.BROWSER) {
              _context10.n = 1;
              break;
            }
            return _context10.a(2);
          case 1:
            txmsg = ((_tx$returnMessage2 = tx.returnMessage) === null || _tx$returnMessage2 === void 0 ? void 0 : _tx$returnMessage2.call(tx)) || {};
            if (!(txmsg.module !== 'Store' || txmsg.request !== 'purchase-asset')) {
              _context10.n = 2;
              break;
            }
            return _context10.a(2);
          case 2:
            web3_purchase = isWeb3PurchaseMessage(txmsg);
            web3_refund_recipient = web3_purchase ? web3RefundRecipient(_this0.app, txmsg) : '';
            if (!(web3_purchase && !web3_refund_recipient)) {
              _context10.n = 3;
              break;
            }
            console.warn('Store: web3 purchase has no refund recipient');
            return _context10.a(2);
          case 3:
            buyer = web3_purchase ? web3_refund_recipient : txmsg.buyer || ((_tx$from2 = tx.from) === null || _tx$from2 === void 0 || (_tx$from2 = _tx$from2[0]) === null || _tx$from2 === void 0 ? void 0 : _tx$from2.publicKey);
            nft_id = String(txmsg.nft_id || '').trim();
            quantity = Number(txmsg.quantity) || 1;
            unit_price = BigInt((_this0$app$wallet$con = _this0.app.wallet.convertSaitoToNolan(txmsg.price)) !== null && _this0$app$wallet$con !== void 0 ? _this0$app$wallet$con : 0);
            fee = BigInt((_this0$app$wallet$con2 = _this0.app.wallet.convertSaitoToNolan(txmsg.fee)) !== null && _this0$app$wallet$con2 !== void 0 ? _this0$app$wallet$con2 : 0);
            total = unit_price * BigInt(quantity) + fee;
            received_block_id = Number((_blk$id = blk === null || blk === void 0 ? void 0 : blk.id) !== null && _blk$id !== void 0 ? _blk$id : 0);
            received_block_hash = String((_blk$hash = blk === null || blk === void 0 ? void 0 : blk.hash) !== null && _blk$hash !== void 0 ? _blk$hash : '');
            received_transaction_id = transactionIndexInBlock(blk, tx);
            refund_public_key = web3_purchase ? web3_refund_recipient : txmsg.refund || buyer;
            if (!(!buyer || !nft_id)) {
              _context10.n = 4;
              break;
            }
            console.warn('Store: purchase missing buyer or nft_id');
            return _context10.a(2);
          case 4:
            if (!(!web3_purchase && unit_price <= 0n)) {
              _context10.n = 5;
              break;
            }
            console.warn('Store: purchase invalid price');
            return _context10.a(2);
          case 5:
            amount_paid = returnAmountPaidInPurchase(tx, txmsg, _this0.app);
            payment_utxo = returnPaymentUtxoFromPurchase(tx, txmsg, _this0.app);
            refund_order = payment_utxo ? _this0.orderFromPurchaseTx(tx, txmsg, payment_utxo, {
              received_block_id: received_block_id,
              received_block_hash: received_block_hash,
              received_transaction_id: received_transaction_id
            }) : null;
            refund = /*#__PURE__*/function () {
              var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(reason) {
                var _t18;
                return _regenerator().w(function (_context1) {
                  while (1) switch (_context1.p = _context1.n) {
                    case 0:
                      if (refund_order) {
                        _context1.n = 1;
                        break;
                      }
                      console.error('Store: refund requires manual investigation because the purchase has no payment output', {
                        purchase_tx_sig: (tx === null || tx === void 0 ? void 0 : tx.signature) || '',
                        block_hash: received_block_hash,
                        reason: reason
                      });
                      return _context1.a(2);
                    case 1:
                      _context1.p = 1;
                      _context1.n = 2;
                      return _this0.propagateOrderRefund(refund_order, {
                        refund_public_key: refund_public_key,
                        reason: reason
                      });
                    case 2:
                      _context1.n = 4;
                      break;
                    case 3:
                      _context1.p = 3;
                      _t18 = _context1.v;
                      console.warn('Store: purchase refund failed', reason, _t18 === null || _t18 === void 0 ? void 0 : _t18.message);
                    case 4:
                      return _context1.a(2);
                  }
                }, _callee0, null, [[1, 3]]);
              }));
              return function refund(_x) {
                return _ref10.apply(this, arguments);
              };
            }();
            if (!isWeb3PurchaseMessage(txmsg)) {
              _context10.n = 7;
              break;
            }
            processors = web3PaymentProcessorKeys(_this0);
            sender = purchaseSenderPublicKey(tx);
            if (processors.includes(sender)) {
              _context10.n = 7;
              break;
            }
            console.warn('Store: web3 purchase is not from the authorized processor', {
              sender: sender,
              authorized: processors
            });
            _context10.n = 6;
            return refund('web3-purchase-unauthorized');
          case 6:
            return _context10.a(2);
          case 7:
            if (!web3_purchase) {
              _context10.n = 10;
              break;
            }
            if (!(amount_paid <= 0n || amount_paid < fee)) {
              _context10.n = 9;
              break;
            }
            console.warn("Store: web3 purchase underpaid. got=".concat(amount_paid, " fee=").concat(fee));
            _context10.n = 8;
            return refund('underpaid');
          case 8:
            return _context10.a(2);
          case 9:
            _context10.n = 12;
            break;
          case 10:
            if (!(amount_paid < total)) {
              _context10.n = 12;
              break;
            }
            console.warn("Store: purchase underpaid. got=".concat(amount_paid, " need=").concat(total));
            _context10.n = 11;
            return refund('underpaid');
          case 11:
            return _context10.a(2);
          case 12:
            if (payment_utxo) {
              _context10.n = 13;
              break;
            }
            console.warn('Store: purchase payment UTXO not found');
            return _context10.a(2);
          case 13:
            _context10.n = 14;
            return _this0.warehouse.returnSummaryByBucket(nft_id, Number(unit_price));
          case 14:
            summary = _context10.v;
            if (!summary) {
              _context10.n = 16;
              break;
            }
            _context10.n = 15;
            return _this0.warehouse.returnAvailableQuantity(summary.nft_id, summary.price);
          case 15:
            _t19 = _context10.v;
            _context10.n = 17;
            break;
          case 16:
            _t19 = 0;
          case 17:
            available = _t19;
            if (!(!summary || available <= 0)) {
              _context10.n = 19;
              break;
            }
            console.warn('Store: purchase summary inactive or missing', nft_id, unit_price.toString());
            _context10.n = 18;
            return refund('listing-inactive');
          case 18:
            return _context10.a(2);
          case 19:
            if (!web3_purchase) {
              _context10.n = 21;
              break;
            }
            listing_ticker = String(summary.web3_ticker || '').trim().toUpperCase();
            listing_amount = Number(summary.web3_amount);
            message_amount = Number(txmsg.web3_amount);
            message_ticker = String(txmsg.web3_ticker || '').trim().toUpperCase();
            if (!(listing_ticker !== message_ticker || !Number.isFinite(listing_amount) || !Number.isFinite(message_amount) || listing_amount !== message_amount)) {
              _context10.n = 21;
              break;
            }
            console.warn('Store: web3 purchase does not match the listing', {
              listing_ticker: listing_ticker,
              message_ticker: message_ticker,
              listing_amount: listing_amount,
              message_amount: message_amount
            });
            _context10.n = 20;
            return refund('web3-listing-mismatch');
          case 20:
            return _context10.a(2);
          case 21:
            if (!(available < quantity)) {
              _context10.n = 23;
              break;
            }
            console.warn('Store: purchase insufficient available quantity', nft_id, unit_price.toString());
            _context10.n = 22;
            return refund('insufficient-quantity');
          case 22:
            return _context10.a(2);
          case 23:
            now = Date.now();
            _context10.p = 24;
            order = _this0.orderFromPurchaseTx(tx, txmsg, payment_utxo, {
              received_block_id: received_block_id,
              received_block_hash: received_block_hash,
              received_transaction_id: received_transaction_id
            });
            order.nft_id = summary.nft_id;
            order.price = Number((_summary$price2 = summary.price) !== null && _summary$price2 !== void 0 ? _summary$price2 : 0);
            order.quantity = quantity;
            order.note = String(txmsg.note || '');
            order.created_at = now;
            order.updated_at = now;
            if (web3_purchase && (!order.inbound_payment_uuid || !order.transfer_uuid)) {
              console.warn('Store: web3 purchase is missing a valid inbound payment id or transfer id', {
                inbound_payment_uuid: txmsg.inbound_payment_uuid,
                transfer_uuid: txmsg.transfer_uuid
              });
            }
            // A different block hash is a new inclusion and gets its own row with its own
            // payment slip; the same block hash is a repeat delivery of one we already hold.
            _context10.n = 25;
            return _this0.warehouse.addOrder(order);
          case 25:
            if (_context10.v) {
              _context10.n = 26;
              break;
            }
            console.log('Store: escrow payment already recorded', tx.signature);
            return _context10.a(2);
          case 26:
            console.log('Store: escrow payment recorded', tx.signature);
            _context10.n = 28;
            break;
          case 27:
            _context10.p = 27;
            _t20 = _context10.v;
            console.warn('Store: escrow payment record failed', _t20 === null || _t20 === void 0 ? void 0 : _t20.message);
            _context10.n = 28;
            return refund('queue-failed');
          case 28:
            return _context10.a(2);
        }
      }, _callee1, null, [[24, 27]]);
    }))();
  }
};